/**
 * Notification domain constants.
 *
 * `NotificationSearchType` lives here rather than in `features/notifications` because it has two
 * consumers on opposite sides of the layer graph: the feature slice (tab state) and the legacy
 * `context/notificationContext`, which polls the `all` scope for the unread badge. `entities` is
 * below both, so neither import points the wrong way.
 */
export const NotificationSearchType = {
  all: 'all',
  important: 'important',
  general: 'general',
  archive: 'archive',
} as const;

export type NotificationSearchTypeValue =
  (typeof NotificationSearchType)[keyof typeof NotificationSearchType];
